import { render, staticRenderFns } from "./OnboardingPhotoEdit.vue?vue&type=template&id=581e6e43&"
import script from "./OnboardingPhotoEdit.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhotoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports